import { createSlice, current } from '@reduxjs/toolkit';
import { v4 as uuidv4 } from 'uuid';

let fakeDataVoiceVlan = {
  enable: false,
  id: '001',
  ouiBindingList: [],
  voiceVlanCos: null,
  voiceVlanId: null,
};

const initialState = {
  resource: 'wiredVoiceVlan',
  data: [],
};

export const voiceVlanSlice = createSlice({
  name: 'wiredVoiceVlan',
  initialState,
  reducers: {
    initVoiceVlan: (state, _) => {
      state.data = fakeDataVoiceVlan;
    },
    addVoiceVlan: (state, action) => {
      // console.log('Add voice vlan: ', action.payload);
      if (!action?.payload?.id) {
        action.payload['id'] = uuidv4();
      }
      state.data = action.payload;
    },
    updateVoiceVlan: (state, action) => {
      // console.log('Update voice vlan: ', action.payload);
      // console.log('reducer:', action.type, current(state));
      state.data = {
        ...state.data,
        ...action.payload,
      };
    },
    deleteVoiceVlan: (state, action) => {
      // console.log('Delete voice vlan: ', action.payload);
      const { voiceVlanIds } = action.payload;
      if (voiceVlanIds.includes(state.data.id)) {
        state.data = null;
      }
    },
  },
});

export const { initVoiceVlan, addVoiceVlan, updateVoiceVlan, deleteVoiceVlan } = voiceVlanSlice.actions;

export default voiceVlanSlice.reducer;
